export default __webpack_public_path__ + "static/media/Strangler's Leggings of Charred Earth.557b59af.jpg";